import { Group, Grid, Stack, Title } from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';
import { useState } from "react";
import { useParams } from "react-router-dom";
import OrderBook from "../../components/symbol-chart/OrderBook/OrderBook";
import SymbolChart from "../../components/symbol-chart/SymbolChart/SymbolChart";
import SpotComponent from "../../components/trades/SpotComponent/SpotComponent";
import UserOrdersComponent from "../../components/trades/UserOrdersComponent/UserOrdersComponent";
import CodeEditor from "../../components/trades/CodeEditor/CodeEditor";
import { SYMBOLS } from "../../constants/symbols";
import ArmADisclosureModal from "../../waves/obstruction/ArmADisclosureModal";
import LoadingComponent from "../../components/loading/LoadingComponent";
import "./ContestSymbolPage.css";

export default function SymbolPage(props) {
  const { name, code } = useParams();
  const symbol = SYMBOLS.find((x) => x.code === code);
  const [closedOrders, setClosedOrders] = useState([]);
  const [openAskOrders, setOpenAskOrders] = useState([]);
  const [openBidOrders, setOpenBidOrders] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const isMobile = useMediaQuery('(max-width: 1090px)');

  // props.user is undefined for one render on a cold/hard load — App.js sets
  // it from CURRENT_USER in a useEffect that fires AFTER the first non-loading
  // render commits. Reading props.user.userid below before that effect runs
  // throws and white-screens the page. Render nothing until it's populated.
  if (!props.user) return <LoadingComponent />;

  return (
    <Stack className="symbol-page" spacing={36}>
      <ArmADisclosureModal />
      <Group className="group">
        {symbol.icon}
        <Title className="title" order={2}>
          {name} ({symbol.symbol})
        </Title>
      </Group>
      <Grid columns={24}>
        {!isMobile && <Grid.Col span={16}>
          <div className="chart-wrapper">
            <SymbolChart className="iframe-element" symbol={symbol} />
          </div>
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <div className="chart-wrapper">
            <SymbolChart className="iframe-element" symbol={symbol} />
          </div>
        </Grid.Col>}
        {!isMobile && <Grid.Col span={8}>
          <div className="spot-component-wrapper">
            <SpotComponent
              symbol={symbol.code}
              ownerId={parseInt(props.user.userid)}
              walletId={parseInt(props.user.userid)}
              setClosedOrders={setClosedOrders}
              setOpenAskOrders={setOpenAskOrders}
              setOpenBidOrders={setOpenBidOrders}
              isActive={isActive}
              setIsActive={setIsActive}
            />
          </div>
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <div className="spot-component-wrapper">
            <SpotComponent
              symbol={symbol.code}
              ownerId={parseInt(props.user.userid)}
              walletId={parseInt(props.user.userid)}
              setClosedOrders={setClosedOrders}
              setOpenAskOrders={setOpenAskOrders}
              setOpenBidOrders={setOpenBidOrders}
              isActive={isActive}
              setIsActive={setIsActive}
            />
          </div>
        </Grid.Col>}
        {!isMobile && <Grid.Col span={24}>
          {isActive && <CodeEditor user={props.user}/>}
        </Grid.Col>}
        {!isMobile && <Grid.Col span={16}>
          <div className="user-orders-wrapper">
            <UserOrdersComponent
              symbol={symbol.code}
              owner={props.user.userid}
              closedOrders={closedOrders}
              setClosedOrders={setClosedOrders}
              openAskOrders={openAskOrders}
              setOpenAskOrders={setOpenAskOrders}
              openBidOrders={openBidOrders}
              setOpenBidOrders={setOpenBidOrders}
            />
          </div>
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <div className="user-orders-wrapper">
            <UserOrdersComponent
              symbol={symbol.code}
              owner={props.user.userid}
              closedOrders={closedOrders}
              setClosedOrders={setClosedOrders}
              openAskOrders={openAskOrders}
              setOpenAskOrders={setOpenAskOrders}
              openBidOrders={openBidOrders}
              setOpenBidOrders={setOpenBidOrders}
            />
          </div>
        </Grid.Col>}
        {!isMobile && <Grid.Col span={8}>
          <div className="order-book-wrapper">
            <OrderBook symbol={symbol.code} />
          </div>
        </Grid.Col>}
        {isMobile && <Grid.Col span={24}>
          <div className="order-book-wrapper">
            <OrderBook symbol={symbol.code} />
          </div>
        </Grid.Col>}
      </Grid>
    </Stack>
  );
}